import { render } from "./AboutPage.vue?vue&type=template&id=5fb2fc23&scoped=true"
import script from "./AboutPage.vue?vue&type=script&lang=js"
export * from "./AboutPage.vue?vue&type=script&lang=js"

import "./AboutPage.vue?vue&type=style&index=0&id=5fb2fc23&lang=scss&scoped=true"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb2fc23"]])

export default __exports__